export enum SettingsKey {
  AddInId = 'deepmm-add-in-id',
  WorksheetId = 'worksheet-id'
}

export enum LocalStorageKey {
  State = 'state'
}